import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  get,
  patch,
  post,
  put
} from "helpers/api_helper";
import {
  ADD_OFFER,
  DELETE_OFFER_STATUS,
  GET_ALL_OFFERS,
  GET_OFFER_DETAILS,
  UPDATE_OFFER,
  UPDATE_OFFER_STATUS,
  GET_OFFER_LIST
} from "helpers/url_helper";

export const getAllOffers = createAsyncThunk(
  GET_ALL_OFFERS,
  async (payload) => {
    const response = await post(GET_ALL_OFFERS, payload);
    return response;
  }
);

export const addOffer = createAsyncThunk(ADD_OFFER, async (payload) => {
  const response = await post(ADD_OFFER, payload);
  return response;
});

export const updateOffer = createAsyncThunk(UPDATE_OFFER, async (payload) => {
  const response = await put(UPDATE_OFFER, payload);
  return response;
});

export const getOfferDetails = createAsyncThunk(
  GET_OFFER_DETAILS,
  async (payload) => {
    const response = await post(GET_OFFER_DETAILS, payload);
    return response;
  }
);

export const deleteOffer = createAsyncThunk(
  DELETE_OFFER_STATUS,
  async (payload) => {
    const response = await del(DELETE_OFFER_STATUS, payload);
    return response;
  }
);

export const updateOfferStatus = createAsyncThunk(
  UPDATE_OFFER_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_OFFER_STATUS, payload);
    return response;
  }
);

export const getOffersList = createAsyncThunk(
  GET_OFFER_LIST,
  async (payload) => {
    const response = await get(`${GET_OFFER_LIST}?type=${payload.type}`);
    return response;
  }
);
